import React, { useEffect, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { getSavedEntList } from '../../actions/contractAdminActions';
// import PropTypes from 'prop-types';
import { getBlockHeight } from '../../util/ContractAdminUtils';
import CASummaryEntFirstSectInfo from './CASummaryEntFirstSectInfo';
import CASummaryEntSecondSectInfo from './CASummaryEntSecondSectInfo';
import CASummaryEntThirdSectInfo from './CASummaryEntThirdSectInfo';
import CASummaryEntForthSectInfo from './CASummaryEntForthSectInfo';
import CASummaryEntFifthSectInfo from './CASummaryEntFifthSectInfo';

const CASummaryEntInfo = ({ savedEntList, setEntitlementFlag }) => {
  const [entitlementList, setEntitlementList] = useState(
    cloneDeep(savedEntList)
  );
  useEffect(() => {
    setEntitlementList(savedEntList);
  }, [savedEntList]);
  const onEntitlementHeaderClicked = entitlement => {
    entitlementList.find(
      entList => entList.entitlementId === entitlement.entitlementId
    ).showDetails = !entitlement.showDetails;
    setEntitlementList([...entitlementList]);
  };
  return (
    <React.Fragment>
      {entitlementList.length && (
        <div>
          {entitlementList.map((item, i) => {
            return (
              <div
                key={item.entitlementId}
                className={`${
                  entitlementList.length - 1 === i && item.showDetails
                    ? 'ent-section-info-bar-border'
                    : ''
                }`}
              >
                <div className="ent-section-info-bar">
                  <span
                    className="ent-name"
                    onClick={() => onEntitlementHeaderClicked(item)}
                  >
                    {item.entitlementName}
                  </span>
                  <span
                    className="ent-edit"
                    onClick={() => {
                      setEntitlementFlag(item.entitlementId);
                    }}
                  >
                    Edit
                  </span>
                </div>
                {item.showDetails && (
                  <div className="ent-info-block">
                    <div className="ent-Info-first-section">
                      <CASummaryEntFirstSectInfo studies={item.studies} />
                    </div>
                    <div className="ent-Info-second-section">
                      <CASummaryEntSecondSectInfo
                        prodData={item.entitlementFeatureSets}
                      />
                    </div>
                    <div className="ent-Info-third-section">
                      <CASummaryEntThirdSectInfo
                        propCodeId={item.propCodeIds}
                      />
                    </div>
                    <div className="ent-Info-forth-section">
                      <CASummaryEntForthSectInfo markets={item.dmaMarkets} />
                    </div>
                    <div className="ent-Info-fifth-section">
                      <CASummaryEntFifthSectInfo
                        memriUsers={item.memriUsersSelectedDtos}
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default CASummaryEntInfo;
